import { render, staticRenderFns } from "./ServiceStartTemplate.vue?vue&type=template&id=713be646"
import script from "./ServiceStartTemplate.vue?vue&type=script&lang=js"
export * from "./ServiceStartTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports